<template>
 <b-navbar type="light">
    <div class="row">
      <img src="https://spaceweather.astron.nl/SolarKSP/data/IDOLSarchive/kspidols.png" width="60px" alt="" class="brand-logo">
      <h1 class="brand-title float-left">LOFAR - Solar catalogue</h1>
    </div>
 </b-navbar>

</template>

<script>
export default {
  name: "Navbar.vue",
}
</script>

<style scoped>
nav {
  background-color: #E1E1E1;
  color: black;
  text-shadow: orange 1px 3px;
  box-shadow: orange 0px 3px 5px;
  margin-bottom: 1rem;
}
.brand-title {
  margin-top: 1rem;
  margin-bottom: auto;
  margin-left: 3rem;
  font-weight: bold;
}

</style>